<template>
    <div
        class="widget-component widget-login-menu widget-login-menu-container"
        :class="[normalizedOptions.container.classes, loggedIn ? 'widget-login-menu--loggedin' : 'widget-login-menu--loggedout']"
        :style="normalizedOptions.container.style"
    >
        <ul class="widget-login-menu-ul">
            <li v-if="normalizedOptions.register.show && !loggedIn">
                <a
                    class="widget-menu-item widget-menu-item-register"
                    :class="normalizedOptions.register.classes"
                    :style="normalizedOptions.register.style"
                    :href="normalizedOptions.register.url"
                >
                    {{ normalizedOptions.register.text }}
                </a>
            </li>
            <li v-if="normalizedOptions.login.show && !loggedIn">
                <a
                    class="widget-menu-item widget-menu-item-login"
                    :class="normalizedOptions.login.classes"
                    :style="normalizedOptions.login.style"
                    :href="normalizedOptions.login.url"
                >
                    {{ normalizedOptions.login.text }}
                </a>
            </li>
            <li v-if="normalizedOptions.logout.show && loggedIn">
                <a
                    class="widget-menu-item widget-menu-item-logout"
                    v-if="normalizedOptions.logout.show"
                    @click="logout"
                    :class="normalizedOptions.logout.classes"
                    :style="normalizedOptions.logout.style"
                >
                    {{ normalizedOptions.logout.text }}
                </a>
            </li>
            <li v-if="loggedIn && normalizedOptions.account.show">
                <a
                    :href="has(normalizedOptions, 'account.url') ? normalizedOptions.account.url : '#'"
                    class="widget-menu-item widget-menu-item-my-account"
                    :class="normalizedOptions.account.classes"
                    :style="normalizedOptions.account.style"
                    v-if="showDropdown == false"
                >
                    {{ normalizedOptions.account.text }}
                </a>
                <v-menu offset-y v-else>
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            v-bind="attrs"
                            v-on="on"
                            href="#"
                            @click.prevent="return null"
                            class="widget-menu-item widget-menu-item-my-account"
                            :class="normalizedOptions.account.classes"
                            :style="normalizedOptions.account.style"
                        >
                            {{ normalizedOptions.account.text }}
                        </a>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in normalizedOptions.dropdown.items"
                            :key="index"
                            v-if="item.show"
                            :href="has(item, 'url') ? item.url : undefined"
                            :target="has(item, 'target') ? item.target : undefined"
                            :class="item.classes"
                            :style="item.style"
                        >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </li>
        </ul>
        <!--

        -->
    </div>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from "@vue/composition-api";
import {merge, has} from "lodash";
import ProfileService from "../services/ProfileService";
import ProfileState from "../state/ProfileState";

export default defineComponent({
    name: "LoginMenu",
    components: {},
    props: {
        settings: {
            type: Object
        },
    },
    setup(props) {
        const loading = ref(false);
        const loggedIn = ref(false);
        const loggedInProfile = ref(false);
        const defaultSettings = ref({
            container: {
                style: '',
                classes: ''
            },
            register: {
                show: true,
                text: 'Create account',
                url: '/register',
                style: '',
                classes: ''
            },
            login: {
                show: true,
                text: 'Login',
                url: '/login',
                style: '',
                classes: ''
            },
            account: {
                show: true,
                text: 'My account',
                style: '',
                classes: '',
                url: '/dashboard',
                showDropdownOptions: false,
            },
            logout: {
                show: true,
                text: 'Logout',
                redirectAfterLogout: '/',
                style: '',
                classes: ''
            },
            dropdown: {
                items: [
                    {
                        show: true,
                        text: "Dashboard",
                        url: '/dashboard',
                        style: '',
                        classes: ''
                    }
                ]
            }
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const showDropdown = computed(() => {
            if(has(normalizedOptions, 'value.account.url') && has(normalizedOptions, 'value.account.showDropdownOptions')) {
                return normalizedOptions.value.account.showDropdownOptions
            }
            return false;
        });



        function logout() {
            ProfileState.clear();
            if(has(normalizedOptions.value, 'logout.redirectAfterLogout')) {
                window.location.href = normalizedOptions.value.logout.redirectAfterLogout;
            } else {
                location.reload();
            }
            return false;
        }

        onMounted(() => {
            init();
        });

        function init() {
            ProfileService.getProfile()
                .then(response => {
                    loggedIn.value = true;
                    loggedInProfile.value = response;
                })
                .catch(error => {
                    console.error(error);
                });
        }

        return {
            // Variables
            loading,
            normalizedOptions,
            loggedIn,
            // Functions
            has,
            logout,
            showDropdown
        };
    }
});
</script>

<style lang="scss">
.widget-login-menu-ul {
    padding: 0px;
    margin: 0px;
    list-style-type: none;
    flex-direction: row;
    li {
        display: inline-block;
        margin-left: 16px;
        a {
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
